var render = function render(){var _vm=this,_c=_vm._self._c;return _c('settings-button',{staticClass:"toggle",class:_vm.isSession || _vm.isAccountSettings ? 'session-toggle' : '',on:{"click":function($event){return _vm.$emit('toggled')}}},[_c('div',{staticClass:"toggle-background",class:_vm.isEnabled ? 'special' : 'grey'},[_c('div',{staticClass:"toggle-circle",class:_vm.isEnabled ? 'enabled' : 'disabled'})])])
}
var staticRenderFns = []

export { render, staticRenderFns }